export default __webpack_public_path__ + "static/media/2.a8b0e0e0.png";